import { RenderDenomination } from "../../../../Components/etc/RenderAmount";
import EditableTransactionNote from "./EditableNote";
import { OwnerCollectionTrList } from "./OwnerCollectionTrList";
import SummaryCardLayout from "./SummaryCardLayout";
import _ from "lodash";

const StatusBadge = ({ status }) => {
  const s = status || "pending";

  const color =
    s === "approved" ? "success" : s === "pending" ? "warning" : "danger";

  return <span className={`badge bg-${color} text-uppercase`}>{s}</span>;
};

export default function FinalSummaryOwnerCollection(props) {
  const { data } = props;

  const cash = Number(data.totalAmountDetails?.cashAmount || 0);
  const online = Number(data.totalAmountDetails?.onlineAmount || 0);
  const adj = Number(data.totalAmountDetails?.adjustedAmount || 0);
  const total = Number(data.totalAmount || 0);

  const INR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

  const renderPreviewContent = (d) => (
    <div className="p-0">
      <div className="fw-semibold small mt-3">Collected Amount Summary</div>
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Cash Collected</td>
            <td className="text-end">{INR(cash)}</td>
          </tr>
          {data.totalAmountDetails.cashDenominations ? (
            <tr>
              <td className="text-muted">Denominations</td>
              <td className="text-end text-muted small">
                <RenderDenomination
                  denominations={data.totalAmountDetails.cashDenominations}
                />
              </td>
            </tr>
          ) : null}
          <tr>
            <td>Online Collected</td>
            <td className="text-end">{INR(online)}</td>
          </tr>
          {adj !== 0 && (
            <tr>
              <td>Adjustment</td>
              <td className="text-end text-danger">{INR(adj)}</td>
            </tr>
          )}
          <tr>
            <td className="fw-bold">Total Amount</td>
            <td className="text-end fw-bold">{INR(total)}</td>
          </tr>
        </tbody>
      </table>

      {d.note && (
        <>
          <div className="fw-semibold small mt-2">Note</div>
          <div className="border rounded p-2 small">{d.note}</div>
        </>
      )}
    </div>
  );

  // ----------------------------------------------------
  // PRINTABLE / SUBMITTED MODE (after DB response)
  // ----------------------------------------------------
  const renderPrintableContent = (d) => (
    <div className="p-0">
      <div className="fw-semibold small mt-3">Collected Amount Summary</div>

      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Cash Collected</td>
            <td className="text-end">
              {INR(d.totalAmountDetails?.cashAmount)}
            </td>
          </tr>
          {data.totalAmountDetails.cashDenominations ? (
            <tr>
              <td className="text-muted">Denominations</td>
              <td className="text-end text-muted small">
                <RenderDenomination
                  denominations={data.totalAmountDetails.cashDenominations}
                />
              </td>
            </tr>
          ) : null}

          <tr>
            <td>Online Collected</td>
            <td className="text-end">
              {INR(d.totalAmountDetails?.onlineAmount)}
            </td>
          </tr>

          {Number(d.totalAmountDetails?.adjustedAmount || 0) !== 0 && (
            <tr>
              <td>Adjustment</td>
              <td className="text-end text-danger">
                {INR(d.totalAmountDetails.adjustedAmount)}
              </td>
            </tr>
          )}

          <tr>
            <td className="fw-bold">Total Amount</td>
            <td className="text-end fw-bold">{INR(d.totalAmount)}</td>
          </tr>

          {/* SHOW STATUS ONLY IN submitted/details */}
          <tr>
            <td>Status</td>
            <td className="text-end fw-bold">
              {/* <StatusBadge status={d.status} /> */}
              {_.startCase(d.status)}
            </td>
          </tr>
        </tbody>
      </table>

      <EditableTransactionNote transaction={d} />

      {/* <div className="fw-semibold small mt-3">
        Available amount before this transaction
      </div>

      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Cash Available</td>
            <td className="text-end">
              {INR(d.officeBalance?.before?.cashAvailable)}
            </td>
          </tr>

          <tr>
            <td>Online Available</td>
            <td className="text-end">
              {INR(d.officeBalance?.before?.onlineAvailable)}
            </td>
          </tr>

          <tr>
            <td className="fw-bold">Total Available</td>
            <td className="text-end fw-bold">
              {INR(d.officeBalance?.before?.totalAvailable)}
            </td>
          </tr>
        </tbody>
      </table> */}

      <OwnerCollectionTrList key={d._id} {...{ transactionId: d._id }} />
    </div>
  );

  // ----------------------------------------------------
  // Determine mode
  // preview  → before submit
  // submitted → after DB response
  // details → viewing existing record
  // ----------------------------------------------------
  let mode = "preview";
  if (props.mode === "details") mode = "details";
  else if (data?.transaction?._id) mode = "submitted";

  // ----------------------------------------------------
  // Final render using SummaryCardLayout
  // ----------------------------------------------------
  return (
    <SummaryCardLayout
      mode={mode}
      data={data}
      renderPreviewContent={renderPreviewContent}
      renderPrintableContent={renderPrintableContent}
      onBack={() => props.onSubmit({ step: data.step - 1 })}
      onSubmit={props.onFinalSubmit}
      onClose={props.handleClose}
      onEdit={props.handleEdit}
      onDelete={props.handleDelete}
      onApprove={props.handleApprove}
    />
  );
}
